import { createSelector } from '@ngrx/store';
import { featureSelect } from '../settings';
const ɵ0 = (state) => state.categories;
export const getRecords = createSelector(featureSelect, ɵ0);
const ɵ1 = (state, recordId) => state.categories.find(record => record.id.toString() === recordId.toString());
export const getRecordById = createSelector(featureSelect, ɵ1);
export { ɵ0, ɵ1 };
